"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$squareAttr = exports.makeSquareAttrRule = void 0;
const inline_1 = require("../../../node/cst/inline");
const factory_1 = require("../factory");
const makeSquareAttrRule = (lazyNameRule) => {
    return factory_1.factory
        .withName("squareAttr")
        .sequence(c => c
        .and(r => r.seqEqual("["))
        .and(lazyNameRule, "name")
        .and(r => r.seqEqual("=\""))
        .and(r => r
        .asSlice(r => r
        // eslint-disable-next-line no-irregular-whitespace
        .oneOrMore(r => r.regExp(/^[^ 　\t\r\n\]"]/))), "value")
        .and(r => r.seqEqual("\"]"))
        .action(({ name, value, text, range }) => {
        const r = range();
        return {
            value: new inline_1.AttrEntry(text(), [name, value], r, "", [r[1], r[1]]),
            errors: [],
        };
    }));
};
exports.makeSquareAttrRule = makeSquareAttrRule;
exports.$squareAttr = (0, exports.makeSquareAttrRule)(r => r
    .asSlice(r => r
    .oneOrMore(r => r
    // eslint-disable-next-line no-irregular-whitespace
    .regExp(/^[^ 　\t\r\n\]=]/))));
exports.default = exports.$squareAttr;
//# sourceMappingURL=$squareAttr.js.map